<template>
  <div>
    <div class="card-box" v-if="cardBag.name">
      <div class="card-box-top-img">
        <img
          src="https://img.esenyun.com/images/20200530/2b707e89206846bba96de36ecc7a03c0.png"
        />
      </div>
      <div style="background:#fff;margin-bottom:16rpx">
        <div class="card-box-title">
          <span class="line"></span>
          <span class="name">可领卡券</span>
          <span class="line"></span>
        </div>
        <div class="coupon-box">
          <div
            class="coupon-box-item"
            v-for="(item, index) in cardBag.children"
            :key="index"
            @click="goToDetails(item.couponId)"
          >
            <CouponType :info="item"></CouponType>
          </div>
        </div>
      </div>
      <div style="background:#fff;">
        <div class="card-box-title">
          <span class="line"></span>
          <span class="name">规则说明</span>
          <span class="line"></span>
        </div>
        <div class="rule-box">
          {{ cardBag.ruleDesc }}
        </div>
      </div>
      <div class="footer flex-center" v-if="!noUse">
        <LinkWeappBtn
          :url="`cardBag/cardBagDetail.html?id=${packageId}&shareId=${shareId}`"
        >
          <script type="text/wxtag-template">
              <style>
                .apply-btn {
                  width: 343px;
                  background: linear-gradient(270deg, #306FE2 24.05%, #1F7DDE 73.62%);
                  color: #fff;
                  font-size: 16px;
                  height: 44px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  border-radius: 40px;
                  border: none;
                }
              </style>
              <button class="apply-btn"> 立即领取
            </button>
          </script>
        </LinkWeappBtn>
      </div>
    </div>
    <van-popup v-model="qrModel" closeable :style="{ width: '100%' }">
      <div class="qr_code">
        <img :src="url" alt="" />
        <div>微信中长按识别小程序码</div>
        <div>领取卡包</div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import CouponType from '../components/CouponType'
import LinkWeappBtn from '../components/LinkWeappBtn'
export default {
  data() {
    return {
      packageId: '',
      loading: false,
      disabled: false,
      qrModel: false,
      showShare: false,
      shareId: '',
      url: '',
      packageInfo: {},
      params: {},
      detail: {},
      cardBag: {},
    }
  },
  // 局部注册的组件
  components: {
    CouponType,
    LinkWeappBtn,
  },
  async mounted() {
    if (!this.$root.$data.store.state.isInitWx) {
      this.$root.$data.store.initwx(true, this.$route.query.code)
    }
    this.packageId = this.$route.query.id
    this.shareId = this.$route.query.shareId
    this.getCouponDetails()
  },
  methods: {
    // 获取卡包详情
    getCouponDetails() {
      this.$http
        .get(`aocampaign/openapi/coupon/package/info/${this.packageId}`)
        .then((res) => {
          if (!res.data) {
            return false
          }
          this.cardBag = res.data
          document.title = this.cardBag.name
        })
    },
    goToDetails() {
      // uni.navigateTo({
      //   url: `/cardBag/couponDetail?id=${id}&from=cardBag&packageId=${this.packageId}`,
      // })
    },
    async getWxcode() {
      this.url = await this.$share.getPosterNew(
        {
          id: this.packageId,
          shareId: this.shareId,
        },
        'cardBag/cardBagDetail'
      )
      this.qrModel = true
    },
  },
}
</script>

<style lang="less" scoped>
.card-box {
  position: relative;
  padding-bottom: 120px;
}
.card-box-top-img img {
  width: 100%;
  height: 99px;
}
.card-box-title {
  padding: 12px 0;
  text-align: center;
  .line {
    display: inline-block;
    width: 32px;
    height: 1px;
    background: #c8c9cc;
    vertical-align: middle;
  }
  .name {
    font-size: 13px;
    margin: 0 8px;
    font-weight: 600;
  }
}
.coupon-box {
  padding: 0 20px 12px;
}
.coupon-box-item {
  margin-bottom: 8px;
}
.rule-box {
  padding: 0 20px 20px;
  font-size: 14px;
  word-break: break-all;
  word-wrap: break-word;
  line-height: 22px;
}
.footer {
  padding: 12px 0 20px 0;
  justify-content: center;
  .btn {
    padding: 0 6px;
  }
}
.items {
  width: 60px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 11px;
  line-height: 20px;
}
</style>
